import {confirmDialog, ConfirmDialogProps} from 'primereact/confirmdialog';
import {useTranslation} from 'react-i18next';

export const useAdminConfirmDialog = () => {
  const {t} = useTranslation();

  const showConfirmDialog = (props: ConfirmDialogProps) => {
    confirmDialog({
      header: t('admin.common.actions.delete'),
      icon: 'fa-regular fa-circle-xmark',
      acceptLabel: t('admin.common.actions.delete'),
      rejectLabel: t('admin.common.actions.cancel'),
      ...props,
    });
  };

  return {showConfirmDialog};
};
